import React from 'react';

import { Row, Divider } from './styles';
import { BoldText, NormalText } from '../../styles';

export default function ItemRow({ title, disableBottomDivider, onClick }) {
  return (
    <div onClick={onClick} style={{ width: '100%' }}>
      <Row>
        <BoldText fontSize="14px">{title}</BoldText>
        <NormalText color="var(--color-blue-primary)">Editar</NormalText>
      </Row>
      {!disableBottomDivider && <Divider />}
    </div>
  );
}
